/**
 * ServiceIcon - renders a service's lucide icon by name (kebab), empty/unknown
 * → default icon `Layers`. Uses lucide's dynamic loader (same pattern as the
 * builder's `LazyIcon`). Shared between the Services admin UIs.
 */
import { Layers } from "lucide-react";
import { DynamicIcon, type IconName } from "lucide-react/dynamic";

export function ServiceIcon({ name, className }: { name?: string | null; className?: string }) {
  const n = (name ?? "").trim();
  if (!n) return <Layers className={className} />;
  return <DynamicIcon name={n as IconName} className={className} fallback={() => <Layers className={className} />} />;
}
